import React, { Component } from 'react';
import { QuestionCircleOutlined, UserOutlined, ShoppingOutlined, CarOutlined, SendOutlined, CustomerServiceOutlined } from '@ant-design/icons';
import faqData from '../data/help-faq.json';
import RelatedLinks from './RelatedLinks';

const iconMap = {
  QuestionCircleOutlined: <QuestionCircleOutlined />,
  UserOutlined: <UserOutlined />,
  ShoppingOutlined: <ShoppingOutlined />,
  CarOutlined: <CarOutlined />,
  SendOutlined: <SendOutlined />,
  CustomerServiceOutlined: <CustomerServiceOutlined />
};

export default class HelpCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSection: faqData.sections[0].id,
      activeQuestion: null
    };
    this.sectionRefs = {};
  }

  scrollToSection = (sectionId) => {
    this.setState({ activeSection: sectionId });
    const el = this.sectionRefs[sectionId];
    if (el) {
      const headerOffset = 100;
      const elTop = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top: elTop, behavior: 'smooth' });
    }
  };

  render() {
    const { sections } = faqData;
    const { activeSection } = this.state;

    return (
      <div className="help-center">
        {/* 标题区 */}
        <div className="hc-header">
          <h1 className="hc-title">帮助中心 — 魔鬼鱼订货平台常见问题（入驻/进货/物流）</h1>
          <p className="hc-subtitle">魔鬼鱼订货平台常见问题解答，涵盖入驻注册、账号管理、货品采购、仓配物流、一件代发</p>
        </div>

        <div className="hc-body">
          {/* 左侧导航 - 桌面端 */}
          <nav className="hc-nav" aria-label="帮助中心分类导航">
            <ul className="hc-nav-list">
              {sections.map(section => (
                <li key={section.id}>
                  <button
                    type="button"
                    className={`hc-nav-item ${activeSection === section.id ? 'active' : ''}`}
                    onClick={() => this.scrollToSection(section.id)}
                  >
                    <span className="hc-nav-icon">{iconMap[section.icon]}</span>
                    <span className="hc-nav-text">{section.title.replace(/^[一二三四五六]、\s*/, '')}</span>
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          {/* 右侧内容 */}
          <div className="hc-content">
            {/* 移动端顶部导航 */}
            <nav className="hc-nav-mobile" aria-label="帮助中心分类导航">
              <div className="hc-nav-mobile-scroll">
                {sections.map(section => (
                  <button
                    key={section.id}
                    type="button"
                    className={`hc-nav-mobile-item ${activeSection === section.id ? 'active' : ''}`}
                    onClick={() => this.scrollToSection(section.id)}
                  >
                    {section.title.replace(/^[一二三四五六]、\s*/, '')}
                  </button>
                ))}
              </div>
            </nav>

            {sections.map(section => (
              <section
                key={section.id}
                id={`section-${section.id}`}
                className="hc-section"
                ref={el => { this.sectionRefs[section.id] = el; }}
              >
                <h2 className="hc-section-title">
                  <span className="hc-section-icon">{iconMap[section.icon]}</span>
                  {section.title}
                </h2>
                <div className="hc-faq-list">
                  {section.faqs.map((faq, idx) => (
                    <div key={`${section.id}-${idx}`} className="hc-faq-item">
                      <h3 className="hc-question">
                        <span className="hc-q-label">Q</span>
                        {faq.q}
                      </h3>
                      <div className="hc-answer">
                        <span className="hc-a-label">A</span>
                        <p>{faq.a}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            ))}

            {/* 联系客服区 */}
            <div className="hc-contact">
              <h2 className="hc-contact-title">还有其他问题？联系魔鬼鱼客服团队</h2>
              <p>如果您在帮助中心没有找到答案，请联系我们的专业服团队</p>
              <div className="hc-contact-qrcode">
                <img src="/images/help-qr-code.png" alt="魔鬼鱼订货平台客服二维码 — 扫码咨询帮助" className="hc-qr-image" loading="lazy" />
                <p className="hc-qr-tip">扫码详细咨询了解</p>
              </div>
            </div>
          </div>
        </div>

        {/* 站内互链（GEO 延伸阅读） */}
        <RelatedLinks
          title="延伸阅读"
          links={[
            { label: '供应商入驻', to: '/supplier' },
            { label: '注册指南', to: '/registration-guide/' },
          ]}
        />
      </div>
    );
  }
}